import { CheckStatus } from "../hooks/CheckStatus";

export const StatusMessage = ({ status }: { status: CheckStatus }) => {

    if (status != CheckStatus.NoError && status != CheckStatus.Error && status != CheckStatus.TooManyErrors) {
        return <></>
    }

    if (status === CheckStatus.TooManyErrors) {
        return (<div className="menu error">Hi ha massa errors (resultats parcials). Verifiqueu l'idioma del text i proveu amb un text més curt.</div>)
    }

    if (status === CheckStatus.Error) {
        return (<div className="menu error">S'ha produït un error en el servidor. Proveu més tard.</div>)
    }

    return (<div className="menu no-error">No s'ha trobat cap error!</div>)
}